/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { v4 } from "uuid";
import {
	appendStyle,
	formatSeconds,
	toMoney,
} from "../../Components/Functions";
import { ModalBox } from "../../Components/ModalBox";
import { loggedUser } from "../../Constants/menus";
import { routers } from "../../Constants/routers";
import { bookSpecialist, checkAvailableDates, updateBooking } from "../../Redux/Booking/actions";
import { login } from "../../Redux/User/actions";
import { LoginForm } from "../auths/Login";
import AvailableDates from "./AvailableDates";


const AppointmentBook = (props) => {
	const { profile, booking, bookSpecialist, user , checkAvailableDates } = props;
	const available_dates = booking?.available_dates || [];
	const [confirmedBooking, setConfirmedBooking] = React.useState(true);
	const [slots, setSlots] = React.useState([{},{},{},{}])
	const updateBooking = (e) => {
		props.updateBooking({ ...booking, ...e });
	};

	const init = () => {
		setTimeout(() => {
			document
				.getElementById("card booking-card")
				.setAttribute("data-x-on:click.away", "closeBookingPanel()");

			let boxes = document.getElementsByClassName("qs-square qs-num");
			boxes.forEach((e) => {
				e.addEventListener("click", (e) => {
					const month = document
						.getElementsByClassName("qs-month")
						?.item(0)?.innerHTML;
					const year = document
						.getElementsByClassName("qs-year")
						?.item(0)?.innerHTML;
					const day = e?.target?.innerHTML;
					const value = {
						date: day + " " + month + " " + year,
						fulldate: new Date(day + " " + month + " " + year),
						components: { day, month, year },
					};
					updateBooking({ date: value });
					document.getElementById("date-input-picker").value = value?.date;
				});
			});
		}, 2000);

		document
			.getElementById("duration-input-field")
			?.addEventListener("input", (e) => {
				console.log(e.target.value);
				updateQuantity(Number(e.target.value));
			});

		bulmaCalendar.attach("#bulma-datepicker-3", {
			displayMode: "inline",
			startDate: new Date(),
			lang: "en",
			minDate: new Date(),
		});

		// To access to bulmaCalendar instance of an element
		var datepicker = document.querySelector("#bulma-datepicker-3");
		if (datepicker) {
			// bulmaCalendar instance is available as element.bulmaCalendar
			datepicker.bulmaCalendar.on("select", function (datepicker) {
				checkAvailableDates({ check_date: datepicker.data.value() });

				// check_date
				// updateBooking({ date_time: datepicker.data.value() });
				// updateSchedules(datepicker.data.value());
			});
		}

		// $(".date-item").on("click", (e) => {
		// 	updateSchedules(document
		// 		.getElementById("bulma-datepicker-3")
		// 		?.bulmaCalendar?.value())
		// })
	};

	React.useEffect(() => {
		appendStyle("assets/css2/datepicker.css");
		init();
	}, []);

	const bookNow = () => {
		const selection = booking.selected_slots || [];
		if (selection?.length < 1){
			alert("Please select a date and time slots.")
			return;
		}
		const data = {
			patient: loggedUser?.id,
			specialist: profile?.id,
			date_time: selection[0]?.date?.date,
			message: booking?.message,
			duration: selection.map(e => { return Number(e.duration) }).reduce((a, b) => a + b, 0),
			time_slots: JSON.stringify(selection.map(e => { return `${e.start_time}-${e.end_time}` }))
		};

		bookSpecialist(data, (res) => {
			if (res?.id > 0) {
				updateBooking({
					response: {
						title: "Appointment Requested",
						message: `Your appointment request has been sent to <strong>${profile?.title} ${profile?.name}</strong>. You will be notified as soon as specialist accepted your request. <br/> Please note that you may be required to pay consultation fee by the specialist.`,
						success: true,
					},
				});
			} else {
				updateBooking({
					response: {
						title: "Appointment Not Requested",
						message:
							res?.detail ||
							`Your appointment request was not sent, please try again later or contact us for more information.`,
						success: false,
					},
				});
			}

			const d = document.getElementById("booking-window-response")
			if(d){
				if(d.classList.contains("is-active")){
					d.classList.remove("is-active")
				}else{
					d.classList.add("is-active")
				}
			}
		});

	


	};

	const updateQuantity = (quantity) => {
		updateBooking({ quantity: quantity > 1 ? quantity : 1 });
	};

	return (
		<>
		<style>
				{`
					.datetimepicker-footer {
						display: none !important;
					}
				`}
			</style>
			<div
				className="card booking-card"
				id="card booking-card"
				data-x-data="initBookingForm()"
				// data-x-on:click.away="closeBookingPanel()"
			>
				<div className="head">
					<span>
						Standard consultation fee is {toMoney(profile?.consultation_fee)}{" "}
						<small>
							per {formatSeconds(profile?.consultation_fee_duration)}
						</small>
					</span>
				</div>
				{/*Dual picker wrapper*/}
				<div
					id="dual-picker-wrapper"
					className="dual-picker-wrapper"
					// dangerouslySetInnerHTML={{ __html: bookingDatePicker({ profile, date: booking?.date, quantity: booking?.quantity, updateQuantity }) }}
				>
					<div class="field">
						<div class="control">
							<input id="bulma-datepicker-3" class="input" type="date" />
						</div>
					</div>
				</div>
				{/* {slots.map((slot) => {
					return (

					)
				})} */}
				{booking?.checking && (
					<div className="booking-list">
						<div className="booking-list-item" style={{ display: "block", paddingBottom: 0, borderBottom: "none" }}>
							<div className="left mb-4">
								<p style={{ fontSize: 14 }}>
									<i className="fas fa-spin fa-spinner mr-3" />
									Fetching doctor's schedule for {booking?.check_date}. Please wait...</p>
							</div>
						</div>
					</div>
				)}

				{!booking?.checking && available_dates?.length > 0 && (
					<AvailableDates data={available_dates} />
				)||(
					<div className="booking-list">
						<div className="booking-list-item" style={{ display: "block", paddingBottom: 0, borderBottom: "none" }}>
							<div className="left mb-4">
								<p style={{ fontSize: 14 }}>
									NO time available on the selected date for this doctor, please select another date.	
								</p>
							</div>
						</div>
					</div>
				)}
				{booking?.selected_slots?.length > 0 && (
					<>
					<div className="dates-head w-100 mt-5">
				<div className="meta w-100 m-0 ">
					<h4 >
						<strong>{formatSeconds(booking.selected_slots.map(e => { return Number(e.duration) }).reduce((a, b) => a + b, 0))}</strong>  {" "}
						totaling <strong>{toMoney( (booking.selected_slots.map(e => { return Number(e.duration) }).reduce((a, b) => a + b, 0)) * profile?.consultation_fee / profile?.consultation_fee_duration )}</strong> {" "}
						selected for booking.
						 
					</h4>
				</div>
			</div>
				<div className="booking-list">
					<div className="booking-list-item" style={{ display: "block", paddingBottom: 0, borderBottom: "none" }}>
						<div className="left mb-4">
							<h4>Additional Message</h4>
						</div>
						<div className="field">
							<div className="control">
								<textarea
									onInput={(e) => updateBooking({ message: e.target.value })}
									className="textarea is-primary-focus"
									rows="3"
									placeholder="Please type any additional message you'd like me to know here..."
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="book-action">
					{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
					<button
						id={user?.auth ? v4() : "proceed-button"}
						onClick={(e) => {
							if (user?.auth) {
								e.preventDefault();
								bookNow();
							}else{
								const d = document.getElementById("login-form-on-booking")
								if(d){
									if(d.classList.contains("is-active")){
										d.classList.remove("is-active")
									}else{
										d.classList.add("is-active")
									}
								}
							}
						}}
						className={`button is-fullwidth is-primary is-raised-hover scroll-link ${
							booking?.booking ? "is-loading" : ""
						}`}
					>
						{user?.auth ? "Book Appointment Now" : "Login to Book Appointment"}
					</button>
					<button id="booking-response" style={{ display: "none" }} >Open</button>
				</div>
					
					</>
				)}
			</div>
			<ModalBox modalId="login-form-on-booking" title="Login" size={"modal-md"} buttonId={"proceed-button"}>
				<LoginForm
					{...props}
					callback={() => {
						window.location = "";
					}}
				/>
			</ModalBox>
			<ModalBox
				title={booking?.response?.title}
				size={"modal-md"}
				modalId={"booking-window-response"}
				buttonId={"booking-response"}
			>
				<p
					dangerouslySetInnerHTML={{ __html: booking?.response?.message || "" }}
				/>
				<a 
					href={routers.dashboard.base}
					className={`modal-trigger button is-fullwidth is-primary is-raised-hover scroll-link mt-4 mb-0`}
				>
					Continue to Dashboard
				</a>
			</ModalBox>
		</>
	);
};

const mapStateToProps = ({ specialist, booking, user }) => {
	return { profile: specialist?.profile || [], booking, user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		bookSpecialist: (e, c) => dispatch(bookSpecialist(e, c)),
		checkAvailableDates: (e, c) => dispatch(checkAvailableDates(e, c)),
		updateBooking: (e) => dispatch(updateBooking(e)),
		login: (e) => dispatch(login(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentBook);
